import React from "react";
import { Form, Input, Typography } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";

/**
 * The transfer reason prints as one paragraph, so it is written as one here
 * too: fixed wording with the four recorded values sitting inline, the same
 * pattern the referral and review forms use for their narrative sections.
 */
const EmergencyReasonForTransfer = () => (
  <Typography className="forms-ip-sentence">
    <Typography.Text>
      During the course of rehabilitation, the patient developed{" "}
    </Typography.Text>
    <Form.Item
      style={{ display: "inline-block" }}
      name={["reasons_for_transfer", "clinical_deterioration"]}
    >
      <Input
        className={inputStyles.mdInput}
        style={{ width: "280px" }}
        placeholder="Clinical deterioration"
      />
    </Form.Item>
    <Typography.Text> presenting with </Typography.Text>
    <Form.Item
      style={{ display: "inline-block" }}
      name={["reasons_for_transfer", "signs_and_symptoms"]}
    >
      <Input
        className={inputStyles.mdInput}
        style={{ width: "280px" }}
        placeholder="Signs and symptoms"
      />
    </Form.Item>
    <Typography.Text>
      {" "}
      Immediate medical assessment and initial stabilisation were carried out,
      including{" "}
    </Typography.Text>
    <Form.Item
      style={{ display: "inline-block" }}
      name={["reasons_for_transfer", "treatment_given"]}
    >
      <Input
        className={inputStyles.mdInput}
        style={{ width: "280px" }}
        placeholder="Treatment given"
      />
    </Form.Item>
    <Typography.Text>
      {" "}
      In view of the patient's clinical condition and the need for further
      specialized evaluation and management, the attendant was counselled
      regarding the need to transfer/shift the patient to{" "}
    </Typography.Text>
    <Form.Item
      style={{ display: "inline-block" }}
      name={["reasons_for_transfer", "hospital_name"]}
    >
      <Input
        className={inputStyles.mdInput}
        style={{ width: "280px" }}
        placeholder="Hospital name"
      />
    </Form.Item>
    <Typography.Text>
      {" "}
      so he is being shifted for the further management.
    </Typography.Text>
  </Typography>
);

export default EmergencyReasonForTransfer;
